import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetProjectSurveyResultsRPC } from "./getProjectSurveyResultsRPC";

export class GetProjectSurveyResultsRPCClientImpl extends GetProjectSurveyResultsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetProjectSurveyResultsRPC.Request): Promise<LeoRPCResult<GetProjectSurveyResultsRPC.Response, GetProjectSurveyResultsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "project/GetProjectSurveyResults",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetProjectSurveyResultsRPC.ResponseDTO,
      GetProjectSurveyResultsRPC.Errors.ErrorsDTO,
      GetProjectSurveyResultsRPC.Response,
      GetProjectSurveyResultsRPC.Errors.Errors
    >(
      response,
      "project/GetProjectSurveyResults",
      GetProjectSurveyResultsRPC.Response.fromDTO,
      GetProjectSurveyResultsRPC.Errors.fromDTO
    );
  }
}
